import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=d6b2eea8"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
import style0 from "./Error.vue?vue&type=style&index=0&id=d6b2eea8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports